export const TranslationKeys = {
  Tower: 'TOWER',
  TowerSize: 'ROWS',
  HandBlackJack: 'HAND_BLACKJACK',
  Limbo: 'LIMBO',
  Limbo10: 'LIMBO_10',
  BlackJack: 'BLACK_JACK',
  Mines: 'MINES',
  Dice: 'DICE',
  Hilo: 'HILO',
  Plinko: 'PLINKO',
  Keno: 'KENO',
  Wheel: 'WHEEL',
  Crash: 'CRASH',
  Football: 'FOOTBALL',
  Roulette: 'ROULETTE',
  FastTrade: 'FAST_TRADE',
  Baccarat: 'BACCARAT',
  Fishing: 'FISHING',
  PowerOfGods: 'POWER_OF_GODS',
  DoubleDice: 'DOUBLE_DICE',
  FirstDice: 'FIRST_DICE',
  SecondDice: 'SECOND_DICE',
  BothDices: 'BOTH_DICES',
  ClassicCrash: 'CLASSIC_CRASH',
  NetworkStatus: 'NETWORK_STATUS',
  MinimumBet: 'MINIMUM_BET',
  MaximumBet: 'MAXIMUM_BET',
  WaitForNextRound: 'WAIT_FOR_NEXT_ROUND',
  Drift: 'DRIFT',
  CoinFlip: 'COIN_FLIP',
  Clear: 'CLEAR',
  Even: 'EVEN',
  AlternativeDice: 'ALTERNATIVE_DICE',
  BetAmount: 'BET_AMOUNT',
  RoundId: 'ROUND_ID',
  Last3Cards: 'LAST_3_CARDS',
  Next3Cards: 'NEXT_3_CARDS',
  Undo: 'UNDO',
  Balance: 'BALANCE',
  MaxPayout: 'MAX_PAYOUT',
  Skip: 'SKIP',
  Stop: 'STOP',
  PlayForReal: 'PLAY_FOR_REAL',
  SelectNumbers: 'SELECT_NUMBERS',
  YouHaveCashedOut: 'YOU_HAVE_CASHED_OUT',
  YourWin: 'YOUR_WIN',
  YouWin: 'YOU_WIN',
  Odds: 'ODDS',
  PlayersDecisions: 'PLAYERS_DECISIONS',
  NextFlipSide: 'NEXT_FLIP_SIDE',
  LastFlipSide: 'LAST_FLIP_SIDE',
  OngoingRound: 'ONGOING_ROUND',
  LastWin: 'LAST_WIN',
  GameHistory: 'GAME_HISTORY',
  Bet: 'BET',
  PressHold: 'PRESS_HOLD',
  Cancel: 'CANCEL',
  Fish: 'FISH',
  StartAutoBet: 'START_AUTO_BET',
  StopAutoBet: 'STOP_AUTO_BET',
  Odd: 'ODD',
  Win: 'WIN',
  Seconds: 'SECONDS',
  GameResolved: 'GAME_RESOLVED',
  Result: 'RESULT',
  Rules: 'RULES',
  History: 'HISTORY',
  Home: 'HOME',
  GameHelp: 'GAME_HELP',
  ConnectionLost: 'CONNECTION_LOST',
  QuickBets: 'QUICK_BETS',
  InvalidSpin: 'INVALID_SPIN',
  MoneyTransactionError: 'MONEY_TRANSACTION_ERROR',
  NextRoundIn: 'NEXT_ROUND_IN',
  JoinTheRound: 'JOIN_THE_ROUND',
  PlayerLimitExceeded: 'PLAYER_LIMIT_EXCEEDED',
  SpinNotFound: 'SPIN_NOT_FOUND',
  InvalidSpinCount: 'INVALID_SPIN_COUNT',
  InvalidAmount: 'INVALID_AMOUNT',
  PartnerNotFound: 'PARTNER_NOT_FOUND',
  Success: 'SUCCESS',
  Refresh: 'REFRESH',
  Reload: 'RELOAD',
  SystemMaintenance: 'SYSTEM_MAINTENANCE',
  YourBetIsAccepted: 'YOUR_BET_IS_ACCEPTED',
  Loading: 'LOADING',
  InOut: 'IN/OUT',
  InvalidToken: 'INVALID_TOKEN',
  PressAnywhereToContinue: 'PRESS_ANYWHERE_TO_CONTINUE',
  TotalBet: 'TOTAL_BET',
  Continue: 'CONTINUE',
  Time: 'TIME',
  GameSettings: 'GAME_SETTINGS',
  Music: 'MUSIC',
  Sound: 'Sound',
  Settings: 'SETTINGS',
  YourConnectionLost: 'YOUR_CONNECTION_LOST',
  DepositNow: 'DEPOSIT_NOW',
  SelectDifferentWallet: 'SELECT_DIFFERENT_WALLET',
  BetCanceled: 'BET_CANCELED',
  InsufficientFunds: 'INSUFFICIENT_FUNDS',
  Previous: 'PREVIOUS',
  Next: 'NEXT',
  Back: 'BACK',
  TargetMultiplier: 'TARGET_MULTIPLIER',
  WinChance: 'WIN_CHANCE',
  AutoBet: 'AUTOBET',
  AutoCashOut: 'AUTO_CASH_OUT',
  ROUND_NUMBER: 'ROUND_NUMBER',
  ThisGame: 'THIS_GAME',
  LiveBets: 'LIVE_BETS',
  AllGames: 'ALL_GAMES',
  HighRollers: 'HIGH_ROLLERS',
  HotKeys: 'HOTKEYS',
  Animation: 'ANIMATION',
  MakeBet: 'MAKE_BET',
  HalfBet: 'HALF_BET',
  Sectors: 'SECTORS',
  DoubleBet: 'DOUBLE_BET',
  HotkeyEnabled: 'HOTKEY_ENABLED',
  Game: 'GAME',
  UserName: 'USERNAME',
  UserId: 'USER_ID',
  Date: 'DATE',
  GameResult: 'GAME_RESULT',
  Payout: 'PAYOUT',
  LastRoundId: 'LAST_ROUND_ID',
  ProvablyFairness: 'PROVABLY_FAIRNESS',
  Key: 'KEY',
  Salt: 'SALT',
  Nice: 'NICE',
  Copied: 'COPIED',
  BetNextRound: 'BET_NEXT_ROUND',
  Epic: 'EPIC',
  Sensational: 'SENSATIONAL',
  InValidAutoCashOutOdd: 'IN_VALID_AUTO_CASH_OUT_ODD',
  MaxBetLimit: 'MAX_BET_LIMIT',
  Hash: 'HASH',
  HashCode: 'HASH_CODE',
  NextRound: 'NEXT_ROUND',
  NextCard: 'NEXT_CARD',
  NextCards: 'NEXT_CARDS',
  NextThreeCards: 'NEXT_THREE_CARDS',
  AboutHash: 'ABOUT_HASH',
  GameRules: 'GAME_RULES',
  Calculator: 'CALCULATOR',
  AboutHashP1: 'ABOUT_HASH_P1',
  AboutHashP2: 'ABOUT_HASH_P2',
  AboutHashP3: 'ABOUT_HASH_P3',
  Calculate: 'CALCULATE',
  Check: 'CHECK',
  CheckHash: 'CHECK_HASH',
  CalculatorP1: 'CALCULATOR_P1',
  CalculatorP2: 'CALCULATOR_P2',
  GameRuleAltDice: 'GAME_RULE_ALT_DICE_P',
  GameRuleAltDicePG: 'GAME_RULE_ALT_DICE1_P',
  GameRulePlinko: 'GAME_RULE_PLINKO_P',
  GameRulePlinkoPG: 'GAME_RULE_PLINKO1_P',
  GameRuleDrift: 'GAME_RULE_DRIFT_P',
  GameRuleDriftPG: 'GAME_RULE_DRIFT1_P',
  GameRuleFootball: 'GAME_RULE_FOOTBALL_P',
  GameRuleFootballPG: 'GAME_RULE_FOOTBALL1_P',
  GameRuleHilo: 'GAME_RULE_HILO_P',
  GameRuleHiloPG: 'GAME_RULE_HILO1_P',
  GameRuleDice: 'GAME_RULE_DICE_P',
  GameRuleDicePG: 'GAME_RULE_DICE1_P',
  GameRuleDoubleDice: 'GAME_RULE_DOUBLE_DICE_P',
  GameRuleCrash: 'GAME_RULE_CRASH_P',
  GameRuleBaccarat: 'GAME_RULE_BACCARAT_P',
  GameRuleBaccaratPG: 'GAME_RULE_BACCARAT1_P',
  GameRuleLimbo: 'GAME_RULE_LIMBO_P',
  GameRuleLimboPG: 'GAME_RULE_LIMBO1_P',
  GameRuleLimbo10: 'GAME_RULE_LIMBO10_P',
  GameRuleFishing: 'GAME_RULE_FISHING_P',
  GameRuleFishingPG: 'GAME_RULE_FISHING1_P',
  GameRuleKeno: 'GAME_RULE_KENO_P',
  GameRuleKenoPG: 'GAME_RULE_KENO1_P',
  GameRuleWheel: 'GAME_RULE_WHEEL_P',
  GameRuleFastTrade: 'GAME_RULE_FAST_TRADE_P',
  GameRuleHandsBJ: 'GAME_RULE_HANDS_BJ_P',
  GameRuleRoulette: 'GAME_RULE_ROULETTE_P',
  GameRuleRoulettePG: 'GAME_RULE_ROULETTE1_P',
  GameRuleCoinFlip: 'GAME_RULE_COINFLIP_P',
  GameRuleCoinFlipPG: 'GAME_RULE_COINFLIP1_P',
  GameRuleBlackJack: 'GAME_RULE_BLACKJACK_P',
  GameRuleBlackJackPG: 'GAME_RULE_BLACKJACK1_P',
  GameRuleMines: 'GAME_RULE_MINES_P',
  GameRuleMinesPG: 'GAME_RULE_MINES1_P',
  GameRuleTowerPG: 'GAME_RULE_TOWER_P',
  AboutHashAltDice: 'ABOUT_HASH_ALT_DICE_P',
  AboutHashCoinFlip: 'ABOUT_HASH_COINFLIP_P',
  AboutHashDrift: 'ABOUT_HASH_DRIFT_P',
  AboutHashKeno: 'ABOUT_HASH_KENO_P',
  AboutHashCrash: 'ABOUT_HASH_CRASH_P',
  AboutHashLimbo: 'ABOUT_HASH_LIMBO_P',
  AboutHashLimbo10: 'ABOUT_HASH_LIMBO10_P',
  AboutHashFastTrade: 'ABOUT_HASH_FAST_TRADE_P',
  AboutHashHandsBJ: 'ABOUT_HASH_HANDS_BJ_P',
  AboutHashRoulette: 'ABOUT_HASH_ROULETTE_P',
  AboutHashBlackJack: 'ABOUT_HASH_BLACKJACK_P',
  AboutHashFootball: 'ABOUT_HASH_FOOTBALL_P',
  AboutHashMines: 'ABOUT_HASH_MINES_P',
  AboutHashWheel: 'ABOUT_HASH_WHEEL_P',
  AboutHashTower: 'ABOUT_HASH_TOWER_P',
  AboutHashDice: 'ABOUT_HASH_DICE_P',
  AboutHashDoubleDice: 'ABOUT_HASH_DOUBLE_DICE_P',
  AboutHashBaccarat: 'ABOUT_HASH_BACCARAT_P',
  AboutHashPlinko: 'ABOUT_HASH_PLINKO_P',
  AboutHashFishing: 'ABOUT_HASH_FISHING_P',
  AboutHashHilo: 'ABOUT_HASH_HILO_P',
  Error: 'ERROR',
  PPair: 'P_PAIR',
  BPair: 'B_PAIR',
  Tie: 'TIE',
  ConnectionIssue: 'CONNECTION_ISSUE',
  PageRefresh: 'PAGE_REFRESH',
  InsufficientBalance: 'INSUFFICIENT_BALANCE',
  BetAccepted: 'BET_ACCEPTED',
  LimitExceeded: 'LIMIT_EXCEEDED',
  MusicIcon: 'MUSIC_ICON',
  SoundIcon: 'SOUND_ICON',
  AnimationIcon: 'ANIMATION_ICON',
  TurboIcon: 'TURBO_ICON',
  HotKeysIcon: 'HOTKEYS_ICON',
  RulesIcon: 'RULES_ICON',
  FairnessIcon: 'FAIRNESS_ICON',
  Gems: 'GEMS',
  Random: 'RANDOM',
  Multiplier: 'MULTIPLIER',
  Roll: 'ROLL',
  Over: 'OVER',
  Under: 'UNDER',
  Toggle: 'TOGGLE',
  LowerTarget: 'LOWER_TARGET',
  HigherTarget: 'HIGHER_TARGET',
  Market: 'MARKET',
  CashOut: 'CASH_OUT',
  High: 'HIGH',
  Medium: 'MEDIUM',
  Low: 'LOW',
  Same: 'SAME',
  Red: 'RED',
  Black: 'BLACK',
  StartCard: 'START_CARD',
  RollOut: 'ROLL_OUT',
  RollIn: 'ROLL_IN',
  KenoClassic: 'CLASSIC',
  KenoLow: 'LOW',
  KenoMedium: 'MEDIUM',
  KenoHigh: 'HIGH',
  PlayerSelection: 'PLAYER_SELECTION',
  RoundResult: 'ROUND_RESULT',
  KenoClearTable: 'CLEAR_TABLE',
  KenoAutoPick: 'AUTO_PICK',
  WheelRisk: 'RISK',
  WheelSector: 'SECTOR',
  Range: 'RANGE',
  PickHead: 'PICK_HEAD',
  PickTail: 'PICK_TAIL',
  MultiSelection: 'MULTI_SELECTION',
  Deal: 'DEAL',
  Hit: 'HIT',
  Stand: 'STAND',
  Split: 'SPLIT',
  Double: 'DOUBLE',
  Insurance: 'INSURANCE',
  AcceptInsurance: 'ACCEPT_INSURANCE',
  NoInsurance: 'NO_INSURANCE',
  UpcomingCards: 'UPCOMING_CARDS',
  PlayersHand: 'PLAYERS_HAND',
  DealersHand: 'DEALERS_HAND',
  MainBet: 'MAIN_BET',
  MainBetDouble: 'MAIN_BET_DOUBLE',
  Lose: 'LOSE',
  Actions: 'ACTIONS',
  ChipValue: 'CHIP_VALUE',
  Player: 'PLAYER',
  Risk: 'RISK',
  Rows: 'ROWS',
  Balls: 'BALLS',
  Banker: 'BANKER',
  TotalBetAmount: 'TOTAL_BET_AMOUNT',
  BetNotAccepted: 'BET_NOT_ACCEPTED',
  InvalidOperation: 'INVALID_OPERATION',
  BetIsAccepted: 'BET_IS_ACCEPTED',
  NotEnoughMoney: 'NOT_ENOUGH_MONEY',
  PleaseRefreshPage: 'PLEASE_REFRESH_PAFGE',
  BetId: 'BET_ID',
  Reconnect: 'RECONNECT',
  PossibleWin: 'POSSIBLE_WIN',
  SelectedMarket: 'SELECTED_MARKET',
  MaintenanceNotify: 'MAINTENANCE_NOTIFY',
  CheckRandomBox: 'RANDOM',
  Surrender: 'SURRENDER',
  freeBet: 'FREE_BET',
  StopAutoFreeBet: 'STOP_AUTO_FREE_BET',
  StartAutoFreeBet: 'START_AUTO_FREE_BET',
  FreeBetTotalWin: 'FREE_BET_TOTAL_WIN',
  FreeBetWinAmount: 'FREE_BET_WIN_AMOUNT',
  FreeBetAmount: 'FREE_BET_AMOUNT',
  FreeBetCongrats: 'FREE_BET_CONGRATS',
  FreeBetCompleted: 'FREE_BET_COMPLETED',
  FreeBets: 'FREE_BETS',
  FreeBetMinOdd: 'FREE_BET_MIN_ODD',
  FreeBetNextRound: 'FREE_BET_NEXT_ROUND',
  FreeBetMaxPayout: 'FREE_BET_MAX_PAYOUT',
  Ok: 'OK',
  Play: 'PLAY',
  FreeBetError: 'FREE_BET_INVALID',
};
